import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-subtab',
  template: `
    <div [hidden]="!active" class="tab-pane">
      <ng-content></ng-content>
    </div>
    `
})
export class CustomSubTabComponent {
  @Input() title: string;
  @Input() active = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/custom-tabs/custom-subtab/custom-tab.component.ts